
import { Checkbox, Tabs, Descriptions, Card, Space, Tag, Button as AntButton } from 'antd';
import { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FileTextOutlined, CalendarOutlined, BulbOutlined, CommentOutlined } from '@ant-design/icons';
import useJustificationModelLatest from './useJustificationModalLatest';
import ActionButtonGradient from '../../../../components/button/ActionButtonGradient';
import axiosInstance from '../../../../services/axios-client';

const JustificationModalLatest = (
    {
        show, 
        handleClose,
        user,
        projectID,
        calibratorID,
        justificationModalUserID,
        onJustificationSaved
    }) => {

    const{
        getJustification,
        latestJustification,
        isLoading,
    } = useJustificationModelLatest()
    
    useEffect(() => {
        if (show) {
            getJustification(projectID, justificationModalUserID, calibratorID)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps        
    }, [justificationModalUserID, show])

    return (
        <Modal show={show} onHide={handleClose} dialogClassName='spmo-justification-modal'>
            <Modal.Header closeButton>
                <Modal.Title><b>Justification Form All Phase</b></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Descriptions 
                    bordered 
                    size="small" 
                    column={1}
                    style={{ marginBottom: '20px' }}
                    labelStyle={{ textAlign: 'left' }}
                    contentStyle={{ textAlign: 'left' }}
                >
                    <Descriptions.Item label="Employee Code">{user.Nik || ""}</Descriptions.Item>
                    <Descriptions.Item label="Employee Name">{user.Name || ""}</Descriptions.Item>
                    <Descriptions.Item label="Designation">{user.Designation || ""}</Descriptions.Item>
                </Descriptions>
                {isLoading ? (
                    <div style={{ padding: '16px 0' }}>
                        <Card loading size="small" style={{ width: '100%' }} />
                    </div>
                ) : (
                    <Tabs
                        defaultActiveKey="1"
                        tabPosition={"top"}
                        size="small"
                    >
                    {
                        latestJustification.map((c) => (
                            <Tabs.TabPane
                                tab={`Phase ${c.ProjectPhase.Phase.Order}`}
                                key={`Phase ${c.ProjectPhase.Phase.Order}`}
                            >
                                <div style={{ padding: '16px 0' }}>
                                    {
                                        c.JustificationType === "top" ? 
                                        <>
                                            <Tag color="blue" style={{ marginBottom: '16px' }}>
                                                Calibrator: {c.Calibrator && c.Calibrator.Name}
                                            </Tag>
                                            
                                            <Space direction="vertical" size="large" style={{ width: '100%' }}>
                                                {c.TopRemarks.map((initiative, index) => (
                                                    <Card
                                                        key={index}
                                                        title={
                                                            <Space>
                                                                <BulbOutlined />
                                                                <span>Initiative {index + 1}</span>
                                                            </Space>
                                                        }
                                                        size="small"
                                                        style={{ width: '100%' }}
                                                    >
                                                        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                                                            {/* Project/Initiative Type Checkboxes */}
                                                            <div>
                                                                <Space size="large">
                                                                    <Checkbox
                                                                        disabled
                                                                        checked={initiative.IsProject}
                                                                    >
                                                                        New Innovation Project
                                                                    </Checkbox>
                                                                    <Checkbox
                                                                        disabled
                                                                        checked={initiative.IsInitiative}
                                                                    >
                                                                        Beyond Job Scope
                                                                    </Checkbox>
                                                                </Space>
                                                            </div>

                                                            {/* Name */}
                                                            <Descriptions size="small" column={1} labelStyle={{ textAlign: 'left' }} contentStyle={{ textAlign: 'left' }}>
                                                                <Descriptions.Item label={
                                                                    <Space>
                                                                        <FileTextOutlined />
                                                                        <span>Name</span>
                                                                    </Space>
                                                                }>
                                                                    {initiative.Initiative}
                                                                </Descriptions.Item>
                                                            </Descriptions>

                                                            {/* Description */}
                                                            <Descriptions size="small" column={1} labelStyle={{ textAlign: 'left' }} contentStyle={{ textAlign: 'left' }}>
                                                                <Descriptions.Item label={
                                                                    <Space>
                                                                        <FileTextOutlined />
                                                                        <span>Description</span>
                                                                    </Space>
                                                                }>
                                                                    <div style={{ whiteSpace: 'pre-wrap', overflow: 'hidden' }}>
                                                                        {initiative.Description}
                                                                    </div>
                                                                </Descriptions.Item>
                                                            </Descriptions>

                                                            {/* Tangible Impact */}
                                                            <Descriptions size="small" column={1} labelStyle={{ textAlign: 'left' }} contentStyle={{ textAlign: 'left' }}>
                                                                <Descriptions.Item label={
                                                                    <Space>
                                                                        <BulbOutlined />
                                                                        <span>Tangible Impact</span>
                                                                    </Space>
                                                                }>
                                                                    <div style={{ whiteSpace: 'pre-wrap', overflow: 'hidden' }}>
                                                                        {initiative.Result}
                                                                    </div>
                                                                </Descriptions.Item>
                                                            </Descriptions>

                                                            {/* Date */}
                                                            <Descriptions size="small" column={1}>
                                                                <Descriptions.Item label={
                                                                    <Space>
                                                                        <CalendarOutlined />
                                                                        <span>Date</span>
                                                                    </Space>
                                                                }>
                                                                    <Space>
                                                                        {new Date(initiative.StartDate).toISOString().split('T')[0] !== "1970-01-01" && (
                                                                            <Tag color="green">
                                                                                {new Date(initiative.StartDate).toLocaleDateString("en-US", { month: "long", year: "numeric" })}
                                                                            </Tag>
                                                                        )}
                                                                        {new Date(initiative.StartDate).toISOString().split('T')[0] !== "1970-01-01" && 
                                                                         new Date(initiative.EndDate).toISOString().split('T')[0] !== "1970-01-01" && (
                                                                            <span>-</span>
                                                                        )}
                                                                        {new Date(initiative.EndDate).toISOString().split('T')[0] !== "1970-01-01" && (
                                                                            <Tag color="orange">
                                                                                {new Date(initiative.EndDate).toLocaleDateString("en-US", { month: "long", year: "numeric" })}
                                                                            </Tag>
                                                                        )}
                                                                    </Space>
                                                                </Descriptions.Item>
                                                            </Descriptions>

                                                            {/* Evidence */}
                                                            {initiative.EvidenceName && (
                                                                <Descriptions size="small" column={1}>
                                                                    <Descriptions.Item label={
                                                                        <Space>
                                                                            <FileTextOutlined />
                                                                            <span>Evidence</span>
                                                                        </Space>
                                                                    }>
                                                                        {initiative.EvidenceLink.includes("calibration-be") || initiative.EvidenceLink === "" ? 
                                                                            <AntButton 
                                                                                type="link" 
                                                                                size="small"
                                                                                onClick={async () => {
                                                                                    const url = `${process.env.REACT_APP_BACKEND_API_URL}/view-initiative/${initiative.ID}`;
                                                                                    const res = await axiosInstance.get(url, { responseType: "blob" });
                                                                                    const link = document.createElement("a");
                                                                                    link.href = URL.createObjectURL(res.data);
                                                                                    link.download = initiative.EvidenceName || "evidence";
                                                                                    link.click();
                                                                                }}
                                                                            >
                                                                                {initiative.EvidenceName}
                                                                            </AntButton>
                                                                        : 
                                                                            <AntButton 
                                                                                type="link" 
                                                                                size="small"
                                                                                onClick={() => {
                                                                                    window.open(initiative.EvidenceURL, '_blank', 'noopener,noreferrer');
                                                                                }}
                                                                            >
                                                                                {initiative.EvidenceName}
                                                                            </AntButton>
                                                                        }
                                                                    </Descriptions.Item>
                                                                </Descriptions>
                                                            )}

                                                            {/* Comment */}
                                                            <Descriptions size="small" column={1} labelStyle={{ textAlign: 'left' }} contentStyle={{ textAlign: 'left' }}>
                                                                <Descriptions.Item label={
                                                                    <Space>
                                                                        <CommentOutlined />
                                                                        <span>Comment</span>
                                                                    </Space>
                                                                }>
                                                                    {initiative.Comment}
                                                                </Descriptions.Item>
                                                            </Descriptions>
                                                        </Space>
                                                    </Card>
                                                ))}
                                            </Space>
                                        </>: 
                                        <></>
                                    }
                                    {
                                        c.JustificationType === "bottom" ? 
                                        <>
                                            <Tag color="blue" style={{ marginBottom: '16px' }}>
                                                Calibrator: {c.Calibrator.Name}
                                            </Tag>
                                            
                                            <Card title="Bottom Remark Details" size="small">
                                                <Descriptions size="small" column={1}>
                                                    {/* <Descriptions.Item label="Attitude">
                                                        {c.BottomRemark.Attitude}
                                                    </Descriptions.Item> */}
                                                    <Descriptions.Item label="Behaviour Issue">
                                                        {c.BottomRemark.Indisipliner}
                                                    </Descriptions.Item>
                                                    <Descriptions.Item label="Performance Issue">
                                                        {c.BottomRemark.LowPerformance}
                                                    </Descriptions.Item>
                                                    {/* <Descriptions.Item label="Warning Letter">
                                                        {c.BottomRemark.WarningLetter}
                                                    </Descriptions.Item> */}
                                                </Descriptions>
                                            </Card>
                                        </>: 
                                        <></>
                                    }
                                    {
                                        c.JustificationType === "default" ? 
                                        <>
                                            <Card title="General Comment" size="small">
                                                <div style={{ whiteSpace: 'pre-wrap', padding: '8px 0' }}>
                                                    {c.Comment}
                                                </div>
                                            </Card>
                                        </>: 
                                        <></>
                                    }
                                </div>
                            </Tabs.TabPane>
                        ))
                    }
                    </Tabs>
                )}
            </Modal.Body>
            <Modal.Footer>
                <ActionButtonGradient
                    onClick={handleClose}
                    variant='danger'
                    children={"Close"}
                />
            </Modal.Footer>
        </Modal>
    );
}

export default JustificationModalLatest